export default "__VITE_ASSET__BaJ6Yqm8__"